/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState, useContext } from "react";
import { lastScale } from "../../../actions/scale.service";
import RescueUnit from "../RescueUnit";
import FireFightingUnit from "../FireFightingUnit";
import ExtraScale from "../ExtraScale";
import { AuthContext } from "../../../actions/auth-context";
import Countdown from "react-countdown";
import styled from "styled-components";
import { FaServer } from "react-icons/fa";

const LastScale = () => {
  const { setLoading } = useContext(AuthContext);

  const [viewScale, setViewScale] = useState(false);

  const [scaleUR, setScaleUR] = useState([]);

  const [scaleUCI, setScaleUCI] = useState([]);

  const [scaleExtra, setScaleExtra] = useState([]);

  const [atualScaleId, setAtualScaleId] = useState(0);

  const [statusServer, setStatusServer] = useState(false);

  const [key, setKey] = useState(1);

  const getScale = useCallback(async () => {
    const response = await lastScale();

    if (response && !response.error && response.units_scales) {
      setLoading(true);

      setStatusServer(true);

      const scales = response.units_scales;

      const defaultUR = [
        {
          vehicle_id: null,
          board_position: 0,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "SOCORRISTA",
              fighter_id: null,
            },
            {
              order: 2,
              function: "SOCORRISTA",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 1,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "SOCORRISTA",
              fighter_id: null,
            },
            {
              order: 2,
              function: "SOCORRISTA",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 2,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "SOCORRISTA",
              fighter_id: null,
            },
            {
              order: 2,
              function: "SOCORRISTA",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 3,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "SOCORRISTA",
              fighter_id: null,
            },
            {
              order: 2,
              function: "SOCORRISTA",
              fighter_id: null,
            },
          ],
        },
      ];

      const defaultUCI = [
        {
          vehicle_id: null,
          board_position: 4,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 2,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 3,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 4,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 5,
              function: "COMBATENTE",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 5,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 2,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 3,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 4,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 5,
              function: "COMBATENTE",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 6,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 2,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 3,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 4,
              function: "COMBATENTE",
              fighter_id: null,
            },
            {
              order: 5,
              function: "COMBATENTE",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 7,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "RESGATISTA",
              fighter_id: null,
            },
            {
              order: 2,
              function: "RESGATISTA",
              fighter_id: null,
            },
            {
              order: 3,
              function: "RESGATISTA",
              fighter_id: null,
            },
            {
              order: 4,
              function: "RESGATISTA",
              fighter_id: null,
            },
            {
              order: 5,
              function: "RESGATISTA",
              fighter_id: null,
            },
          ],
        },
      ];

      const defaultEXTRA = [
        {
          vehicle_id: null,
          board_position: 8,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "BV",
              fighter_id: null,
            },
            {
              order: 2,
              function: "BV",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 9,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "BV",
              fighter_id: null,
            },
            {
              order: 2,
              function: "BV",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 10,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "BV",
              fighter_id: null,
            },
            {
              order: 2,
              function: "BV",
              fighter_id: null,
            },
          ],
        },
        {
          vehicle_id: null,
          board_position: 11,
          fighters_scales: [
            {
              order: 0,
              function: "MOTORISTA",
              fighter_id: null,
            },
            {
              order: 1,
              function: "BV",
              fighter_id: null,
            },
            {
              order: 2,
              function: "BV",
              fighter_id: null,
            },
          ],
        },
      ];

      if (atualScaleId !== response.id) {
        let ur_data = [];
        let uci_data = [];
        let extra_data = [];

        const position0 = scales.filter((item) => item.board_position === 0);
        ur_data.push(position0[0]);

        const position1 = scales.filter((item) => item.board_position === 1);
        ur_data.push(position1[0]);

        const position2 = scales.filter((item) => item.board_position === 2);
        ur_data.push(position2[0]);

        const position3 = scales.filter((item) => item.board_position === 3);
        ur_data.push(position3[0]);

        const position4 = scales.filter((item) => item.board_position === 4);
        uci_data.push(position4[0]);

        const position5 = scales.filter((item) => item.board_position === 5);
        uci_data.push(position5[0]);

        const position6 = scales.filter((item) => item.board_position === 6);
        uci_data.push(position6[0]);

        const position7 = scales.filter((item) => item.board_position === 7);
        uci_data.push(position7[0]);

        const position8 = scales.filter((item) => item.board_position === 8);
        extra_data.push(position8[0]);

        const position9 = scales.filter((item) => item.board_position === 9);
        extra_data.push(position9[0]);

        const position10 = scales.filter((item) => item.board_position === 10);
        extra_data.push(position10[0]);

        const position11 = scales.filter((item) => item.board_position === 11);
        extra_data.push(position11[0]);

        // Normaliza dados: garante que cada posição tenha fighters_scales como array
        for (let i = 0; i < ur_data.length; i++) {
          const element = ur_data[i];

          if (!element || !Array.isArray(element.fighters_scales)) {
            ur_data[i] = defaultUR[i];
          }
        }

        for (let i = 0; i < uci_data.length; i++) {
          const element = uci_data[i];

          if (!element || !Array.isArray(element.fighters_scales)) {
            uci_data[i] = defaultUCI[i];
          }
        }

        for (let i = 0; i < extra_data.length; i++) {
          const element = extra_data[i];

          if (!element || !Array.isArray(element.fighters_scales)) {
            extra_data[i] = defaultEXTRA[i];
          }
        }

        setScaleUR(ur_data);

        setScaleUCI(uci_data);

        setScaleExtra(extra_data);

        setViewScale(true);

        setAtualScaleId(response.id);
      }
    } else {
      setStatusServer(false);
    }

    setLoading(false);
  }, [atualScaleId]);

  const Completionist = () => <span>You are good to go!</span>;

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return <span>{seconds < 10 ? `0${seconds}` : seconds}</span>;
    }
  };

  const loadLastScale = useCallback(async () => {
    setInterval(() => {
      getScale();
    }, 30000);
  }, []);

  useEffect(() => {
    getScale();
    loadLastScale();
  }, []);

  return (
    <div className="px-3">
      {!viewScale ? (
        <div className="row mt-5">
          <div className="col text-center">
            <div className="alert alert-danger" role="alert">
              Nenhuma escala de trabalho encontrada!
            </div>
          </div>
        </div>
      ) : (
        <div className="row">
          <Status className="col text-center d-md-none">
            <div className="d-flex">
              <Timer>
                <Countdown
                  date={Date.now() + 30000}
                  key={key}
                  onComplete={() => {
                    setKey(key + 1);
                  }}
                  renderer={renderer}
                />
              </Timer>

              <Server className="col" status={statusServer}>
                <FaServer />

                <div>{statusServer ? "SERVER ON" : "SERVER OFF"}</div>
              </Server>
            </div>
          </Status>

          <div className="col-sm col-md-9">
            <div className="row">
              {scaleUR.map((item, index) => (
                <RescueUnit key={index} scale={item} />
              ))}
            </div>

            <div className="row">
              <div className="col-sm col-md-3 text-center">
                <FireFightingUnit
                  scale={scaleUCI[0]}
                  title="UCI 1ª ESCALA"
                  type="uci1"
                />
              </div>

              <div className="col-sm col-md-3 text-center">
                <FireFightingUnit
                  scale={scaleUCI[1]}
                  title="UCI 2ª ESCALA"
                  type="COMBATENTES"
                />
              </div>

              <div className="col-sm col-md-3 text-center">
                <FireFightingUnit
                  scale={scaleUCI[2]}
                  title="UCI FLORESTAL"
                  type="COMBATENTES"
                />
              </div>

              <div className="col-sm col-md-3 text-center">
                <FireFightingUnit
                  scale={scaleUCI[3]}
                  title="UN. DE RESGATE"
                  type="RESGATISTAS"
                />
              </div>
            </div>
          </div>

          <div className="col">
            <Status className="col text-center d-none d-md-block">
              <div className="d-flex">
                <Timer>
                  <Countdown
                    date={Date.now() + 30000}
                    key={key}
                    onComplete={() => {
                      setKey(key + 1);
                    }}
                    renderer={renderer}
                  />
                </Timer>

                <Server className="col" status={statusServer}>
                  <FaServer />

                  <div>{statusServer ? "SERVER ON" : "SERVER OFF"}</div>
                </Server>
              </div>
            </Status>

            <ExtraScale scale={scaleExtra} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LastScale;

const Status = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 5px;
  width: 180px;
  margin-top: -80px;
  margin-left: -60px;
  padding-top: 10px;
  padding-bottom: 10px;

  @media only screen and (max-width: 780px) {
    position: relative;
    margin-top: 0;
    margin-left: 0;
    width: 160px;
  }

  @media only screen and (max-width: 600px) {
    position: relative;
    margin-top: 0;
    margin-left: 25%;
    width: 160px;
  }

  @media only screen and (max-width: 300px) {
    position: relative;
    margin-top: 0;
    margin-left: 10%;
    width: 160px;
  }
`;

const Server = styled.div`
  font-size: 12px;
  padding: 0;
  margin-bottom: 0;
  font-weight: bold;
  color: ${(props) => (props.status ? "green" : "red")};

  svg {
    font-size: 36px;
    color: ${(props) => (props.status ? "green" : "red")};
  }
`;

const Timer = styled.div`
  font-family: "Stick No Bills", sans-serif;
  font-weight: bold;
  border: 1px solid #999;
  border-radius: 5px;
  margin-left: 10px;
  padding-left: 10px;
  padding-right: 10px;
  width: 60px;

  @media only screen and (min-width: 1920px) {
    font-size: 46px;

    svg {
      height: 50px;
      width: 50px;
      margin-top: -15px;
    }
  }

  @media only screen and (max-width: 1920px) {
    font-size: 36px;

    svg {
      margin-top: -15px;
    }
  }
`;
